<template>
  <div class="wrapper">
    <parallax
      class="section page-header header-filter"
      parallax-active="true"
      :style="headerStyle"
    >
      <div class="container">
        <div class="md-layout">
<!--          <div class="md-layout-item md-size-50 md-small-size-100">
            <h1 class="title">
              Your Story Starts With Us.
            </h1>
            <h4>
              Every landing page needs a small description after the big bold
              title, that's why we added this text here. Add here all the
              information that can make you or your product create the first
              impression.
            </h4>
            <br>
            <md-button
              href="https://www.youtube.com/watch?v=dQw4w9WgXcQ"
              class="md-success md-lg"
              target="_blank"
            >
              <i class="fas fa-play" /> Watch video
            </md-button>
          </div>-->
        </div>
      </div>
    </parallax>
    <div class="main main-raised">
      <div class="section">
        <div class="container">
          <div class="md-layout">
            <div
              class="md-layout-item md-size-66 md-small-size-100 mx-auto text-center"
            >
              <h2 class="title text-center">
                Let's talk product
              </h2>
              <h5 class="description">
                We have three products to help the traffic owners at the three levels of high, middle and low to monetize. Please briefly browse the brief overview of the three products below. If you have any intention of cooperation, please <md-icon>fingerprint</md-icon><a href="#/contact-us">Contact Us</a>
              </h5>
            </div>
          </div>
          <div class="features text-center">
            <div class="md-layout">
              <div class="md-layout-item md-size-33 md-small-size-100">
                <div class="info">
                  <div class="icon icon-info">
                    <md-icon>add_link</md-icon>
                  </div>
                  <h4 class="info-title">
                    <a target="_blank" href="#/superlink-page">HyperLinks</a>
                  </h4>
                  <p>
                    Hyperlinks save more operating costs for the publishers, and at the same time bring more revenues.We will check the Fraud, Brand safety, and match more valuable offers and creatives for maximize ROI.
                  </p>
                </div>
              </div>
              <div class="md-layout-item md-size-33 md-small-size-100">
                <div class="info">
                  <div class="icon icon-success">
                    <md-icon>account_tree</md-icon>
                  </div>
                  <h4 class="info-title">
                    <a target="_blank" href="#/adnetwork-page">AdNetwork</a>
                  </h4>
                  <p>
                    AdNetwork can help publishers reach more advertisers and more types of Campaigns, simple integration and flexible for  start and stop. Publishers can get our services and monetization capabilities more quickly.                  </p>
                </div>
              </div>
              <div class="md-layout-item md-size-33 md-small-size-100">
                <div class="info">
                  <div class="icon icon-danger">
                    <md-icon>sync</md-icon>
                  </div>
                  <h4 class="info-title">
                    <a target="_blank" href="#/xtrading-page">Xtrading</a>
                  </h4>
                  <p>
                    X trading can help developers who have high-quality applications to achieve stable monetization. Advertisers can directly base the  CPT-PT(between RTB & CPT/M)  model to buy placements and traffic.
                    A better choice  When the  IOS14.5 coming &  ATT upgraded.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section text-center">
        <div class="container">
          <h2 class="title">
            Here is our great partner
          </h2>
          <el-carousel :interval="1000" type="card" indicator-position="none"	>
            <el-carousel-item v-for="item in partnerprofiles" :key="item">
              <div><img style="border-radius: 22.5%;height: 230px;width: 230px" :src="item"/></div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div class="section section-contacts">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item md-size-66 md-small-size-100 mx-auto">
              <h2 class="text-center title">
                Work with us
              </h2>
              <h4 class="text-center description">
                Divide details about your product or agency work into parts.
                Write a few lines about each one and contact us about any
                further collaboration. We will responde get back to you in a
                couple of hours.
              </h4>
              <form class="contact-form">
                <div class="md-layout">
                  <div class="md-layout-item md-size-50 md-small-size-100">
                    <md-field>
                      <label>Your Name</label>
                      <md-input
                        v-model="name"
                        type="text"
                      />
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-50 md-small-size-100">
                    <md-field>
                      <label>Your Email</label>
                      <md-input
                        v-model="email"
                        type="email"
                      />
                    </md-field>
                  </div>
                </div>
                <md-field maxlength="5">
                  <label>Your Message</label>
                  <md-textarea v-model="message" />
                </md-field>
                <div class="md-layout">
                  <div
                    class="md-layout-item md-size-33 md-small-size-100 mx-auto text-center"
                  >
                    <md-button class="md-success">
                      Send Message
                    </md-button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ProfileCard } from "@/components";
import Mixins from "@/plugins/basicMixins";

export default {
/*  components: {
    ProfileCard
  },*/
  mixins: [Mixins.HeaderImage],
  bodyClass: "landing-page",
  data() {
    return {
      image: require("@/assets/img/bg/b4.jpg"),
      name: null,
      email: null,
      message: null,
      partnerprofiles: {
        cardProfile2: require("@/assets/img/partnericon/Imgur.png"),
        cardProfile3: require("@/assets/img/partnericon/Jigsaw.png"),
        cardProfile4: require("@/assets/img/partnericon/MoviePosterMania.png"),
        cardProfile5: require("@/assets/img/partnericon/Musi.png"),
        cardProfile6: require("@/assets/img/partnericon/Stickers.png"),
        cardProfile7: require("@/assets/img/partnericon/TriviaCrack.png"),
        cardProfile8: require("@/assets/img/partnericon/color.png"),
        cardProfile9: require("@/assets/img/partnericon/ifunny.png"),
        cardProfile10: require("@/assets/img/partnericon/lazada.png"),
        cardProfile11: require("@/assets/img/partnericon/meetme.png"),
        cardProfile12: require("@/assets/img/partnericon/skout.png"),
        cardProfile13: require("@/assets/img/partnericon/tagged.png"),
        cardProfile14: require("@/assets/img/partnericon/thescore.png"),
        cardProfile15: require("@/assets/img/partnericon/weheartit.png")
      },
      cardProfile3: {
        cardProfile1: require("@/assets/img/faces/card-profile1-square.jpg"),
        cardProfile2: require("@/assets/img/faces/card-profile6-square.jpg"),
        cardProfile3: require("@/assets/img/faces/card-profile4-square.jpg"),
        cardProfile4: require("@/assets/img/faces/card-profile2-square.jpg")
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}
.contact-form {
  margin-top: 30px;
}

.md-has-textarea + .md-layout {
  margin-top: 15px;
}
.el-carousel{
  margin-top: 150px;
}
.el-carousel__item{
  font-size: 18px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}
</style>
